import { render, staticRenderFns } from "./ApiList.vue?vue&type=template&id=0a8942c4&scoped=true"
import script from "./ApiList.vue?vue&type=script&lang=js"
export * from "./ApiList.vue?vue&type=script&lang=js"
import style0 from "./ApiList.vue?vue&type=style&index=0&id=0a8942c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8942c4",
  null
  
)

export default component.exports